var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxoneicons3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005c74;}.cls-2{fill:#01cab8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.06,3H29.94A27,27,0,0,0,3,29.94V226.06A27,27,0,0,0,29.94,253H226.06A27,27,0,0,0,253,226.06V29.94A27,27,0,0,0,226.06,3ZM186.84,56.87a12.31,12.31,0,0,1,12.29,12.29V186.84a12.31,12.31,0,0,1-12.29,12.29H69.16a12.31,12.31,0,0,1-12.29-12.29V69.16A12.31,12.31,0,0,1,69.16,56.87ZM17.65,96.1H42.23v63.8H17.65Zm0,78.45H42.23v12.29a26.9,26.9,0,0,0,3,12.29H17.65ZM42.23,69.16V81.45H17.65V56.87H45.2A26.9,26.9,0,0,0,42.23,69.16Zm196.12,156.9a12.3,12.3,0,0,1-12.29,12.29H29.94a12.3,12.3,0,0,1-12.29-12.29V213.78H186.84a27,27,0,0,0,26.93-26.94V69.16a27,27,0,0,0-26.93-26.94H17.65V29.94A12.3,12.3,0,0,1,29.94,17.65H226.06a12.3,12.3,0,0,1,12.29,12.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.54,166.46a7.32,7.32,0,0,0,10.36,0l6.42-6.42a38.62,38.62,0,0,0,43.36,0l6.42,6.42a7.33,7.33,0,0,0,10.36-10.36L160,149.68a38.62,38.62,0,0,0,0-43.36l6.42-6.42A7.33,7.33,0,1,0,156.1,89.54L149.68,96a38.62,38.62,0,0,0-43.36,0L99.9,89.54A7.33,7.33,0,1,0,89.54,99.9L96,106.32a38.57,38.57,0,0,0,0,43.36l-6.42,6.42A7.33,7.33,0,0,0,89.54,166.46ZM152.06,128A24.06,24.06,0,1,1,128,103.94,24.1,24.1,0,0,1,152.06,128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxoneicons3);
export default __webpack_public_path__ + "static/media/rx one icons (3).56977c72b68adca2e464be2394fdbc4d.svg";
export { ForwardRef as ReactComponent };